module.exports = __webpack_public_path__ + "static/img/run2023_pending original.9a66b3d4.jpg";